<main class="buyer-guide">
  <section class="buyer-guide__hero" aria-labelledby="buyer-guide-title">
    <img
      class="buyer-guide__hero-image"
      [src]="assetPaths.images.heroes.guidesUltrawide"
      alt=""
      aria-hidden="true">
    <div class="buyer-guide__hero-overlay">
      <p class="buyer-guide__eyebrow">Gabali Realty · Laredo &amp; South Texas</p>
      <h1 id="buyer-guide-title" class="buyer-guide__hero-title">Buyer's Guide</h1>
      <p class="buyer-guide__hero-subtitle">
        A clear path from first conversation to closing day — with local expertise at every step.
      </p>
    </div>
  </section>

  <section class="buyer-guide__intro">
    <p class="buyer-guide__lede">
      Buying a home is one of the biggest decisions you will make. Gabali Realty breaks the process into
      five manageable steps so you always know what comes next — and who is handling it for you.
    </p>
    <ul class="buyer-guide__highlights">
      @for (item of highlights; track item) {
        <li class="buyer-guide__highlight">{{ item }}</li>
      }
    </ul>
  </section>

  <section class="buyer-guide__steps" aria-labelledby="steps-heading">
    <header class="buyer-guide__section-header">
      <h2 id="steps-heading" class="buyer-guide__section-title">5 Steps to Your New Home</h2>
      <p class="buyer-guide__section-intro">
        Tap a step below to see what happens and how your Gabali agent supports you through it.
      </p>
    </header>
    <app-buy-guide-card></app-buy-guide-card>
  </section>

  <section class="buyer-guide__budget" aria-labelledby="budget-heading">
    <header class="buyer-guide__section-header">
      <h2 id="budget-heading" class="buyer-guide__section-title">What to Budget Beyond the Price</h2>
      <p class="buyer-guide__section-intro">
        The list price is only part of the picture. Plan for these common costs so there are no surprises at closing.
      </p>
    </header>
    <ul class="buyer-guide__budget-list">
      @for (item of budgetItems; track item.title) {
        <li class="buyer-guide__budget-item">
          <span class="buyer-guide__budget-title">{{ item.title }}</span>
          <span class="buyer-guide__budget-detail">{{ item.detail }}</span>
        </li>
      }
    </ul>
  </section>

  <section class="buyer-guide__resources" aria-labelledby="resources-heading">
    <header class="buyer-guide__section-header">
      <h2 id="resources-heading" class="buyer-guide__section-title">Tools to Get Started</h2>
      <p class="buyer-guide__section-intro">
        Use these resources on your own time, then loop in an agent when you are ready to tour or make an offer.
      </p>
    </header>
    <div class="buyer-guide__resource-grid">
      @for (resource of resources; track resource.title) {
        <article class="buyer-guide__resource-card">
          <h3 class="buyer-guide__resource-title">{{ resource.title }}</h3>
          <p class="buyer-guide__resource-copy">{{ resource.description }}</p>
          <a class="buyer-guide__resource-link" [routerLink]="resource.link">
            {{ resource.linkLabel }}
            <span aria-hidden="true">→</span>
          </a>
        </article>
      }
    </div>
  </section>

  <section class="buyer-guide__local" aria-labelledby="local-heading">
    <header class="buyer-guide__section-header">
      <h2 id="local-heading" class="buyer-guide__section-title">Laredo Market Tips</h2>
      <p class="buyer-guide__section-intro">
        Every market has nuances. These are the questions our buyers ask most often when narrowing their search.
      </p>
    </header>
    <div class="buyer-guide__tips-grid">
      @for (tip of localTips; track tip.title) {
        <article class="buyer-guide__tip-card">
          <h3 class="buyer-guide__tip-title">{{ tip.title }}</h3>
          <p class="buyer-guide__tip-copy">{{ tip.description }}</p>
        </article>
      }
    </div>
  </section>

  <section class="buyer-guide__cta" aria-labelledby="cta-heading">
    <h2 id="cta-heading" class="buyer-guide__cta-title">Ready to take the first step?</h2>
    <p class="buyer-guide__cta-copy">
      Talk with a Gabali agent about your timeline, budget, and neighborhoods — no pressure, just a plan.
    </p>
    <div class="buyer-guide__cta-actions">
      <a class="buyer-guide__cta-btn buyer-guide__cta-btn--primary" routerLink="/agents">Meet an Agent</a>
      <a class="buyer-guide__cta-btn buyer-guide__cta-btn--secondary" routerLink="/contact-page">Contact Us</a>
      <a class="buyer-guide__cta-btn buyer-guide__cta-btn--secondary" routerLink="/featured-properties">Browse Listings</a>
    </div>
  </section>
</main>
